import { render, staticRenderFns } from "./currentInventory.vue?vue&type=template&id=444bf12c&scoped=true"
import script from "./currentInventory.vue?vue&type=script&lang=js"
export * from "./currentInventory.vue?vue&type=script&lang=js"
import style0 from "./currentInventory.vue?vue&type=style&index=0&id=444bf12c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "444bf12c",
  null
  
)

export default component.exports